import { ScreenLayout } from '@components/Layouts'
import { AnsweredTasks as AnsweredTasksList } from '@components/Task'
import { useI18n } from '@lib/i18n'
import { useTasksStore } from '@stores/tasks'
import { useEffect, useState } from 'react'

export function AnsweredTasks() {
  const t = useI18n()
  const [isLoading, setLoading] = useState(false)
  const [getAnsweredTasks] = useTasksStore((state) => [state.getAnsweredTasks])

  useEffect(() => {
    setLoading(true)
    getAnsweredTasks().finally(() => setLoading(false))
  }, [])

  return (
    <ScreenLayout title={t('screen.answeredTasks')} isLoading={isLoading} hasBack>
      <AnsweredTasksList />
    </ScreenLayout>
  )
}
